// src/data/vocabularies/M1_vocabulary.js

const M1_base = {

  // ══════════════════════════════
  // UNIT 01 — Introducing yourself
  // ══════════════════════════════
  'hello':          { translation: 'hola' },
  'hi':             { translation: 'hola (informal)' },
  'my name is':     { translation: 'mi nombre es' },
  'i am':           { translation: 'yo soy / yo tengo' },
  'name':           { translation: 'nombre' },
  'first name':     { translation: 'nombre de pila' },
  'last name':      { translation: 'apellido' },
  'spell':          { translation: 'deletrear' },
  'greeting':       { translation: 'saludo' },
  'letter':         { translation: 'letra' },
  'alphabet':       { translation: 'alfabeto' },

  // ══════════════════════════════
  // UNIT 02 — Countries
  // ══════════════════════════════
  'country':        { translation: 'país' },
  'countries':      { translation: 'países' },
  'mexico':         { translation: 'México' },
  'canada':         { translation: 'Canadá' },
  'brazil':         { translation: 'Brasil' },
  'france':         { translation: 'Francia' },
  'spain':          { translation: 'España' },
  'germany':        { translation: 'Alemania' },
  'china':          { translation: 'China' },
  'japan':          { translation: 'Japón' },
  'india':          { translation: 'India' },
  'australia':      { translation: 'Australia' },
  'russia':         { translation: 'Rusia' },
  'egypt':          { translation: 'Egipto' },
  'turkey':         { translation: 'Turquía' },
  'argentina':      { translation: 'Argentina' },

  // ══════════════════════════════
  // UNIT 03 — Age & Nationality
  // ══════════════════════════════
  'age':            { translation: 'edad' },
  'years old':      { translation: 'años de edad' },
  'how old are you':{ translation: '¿cuántos años tienes?' },
  'nationality':    { translation: 'nacionalidad' },
  'where are you from': { translation: '¿de dónde eres?' },
  'i am from':      { translation: 'soy de' },
  'american':       { translation: 'americano/a' },
  'mexican':        { translation: 'mexicano/a' },
  'british':        { translation: 'británico/a' },
  'french':         { translation: 'francés/francesa' },
  'spanish':        { translation: 'español/española' },
  'german':         { translation: 'alemán/alemana' },
  'chinese':        { translation: 'chino/a' },
  'japanese':       { translation: 'japonés/japonesa' },
  'australian':     { translation: 'australiano/a' },
  'russian':        { translation: 'ruso/a' },
  'canadian':       { translation: 'canadiense' },
  'brazilian':      { translation: 'brasileño/a' },
  'indian':         { translation: 'indio/a' },

  // ══════════════════════════════
  // UNIT 04 — Family & Pets
  // ══════════════════════════════
  'family':         { translation: 'familia' },
  'mother':         { translation: 'madre' },
  'father':         { translation: 'padre' },
  'mom':            { translation: 'mamá' },
  'dad':            { translation: 'papá' },
  'sister':         { translation: 'hermana' },
  'brother':        { translation: 'hermano' },
  'grandmother':    { translation: 'abuela' },
  'grandfather':    { translation: 'abuelo' },
  'grandparents':   { translation: 'abuelos' },
  'aunt':           { translation: 'tía' },
  'uncle':          { translation: 'tío' },
  'cousin':         { translation: 'primo/a' },
  'wife':           { translation: 'esposa' },
  'husband':        { translation: 'esposo' },
  'son':            { translation: 'hijo' },
  'daughter':       { translation: 'hija' },
  'children':       { translation: 'hijos / niños' },
  'parents':        { translation: 'padres' },
  'pet':            { translation: 'mascota' },
  'cat':            { translation: 'gato' },
  'dog':            { translation: 'perro' },
  'rabbit':         { translation: 'conejo' },
  'fish':           { translation: 'pez / pescado' },
  'hamster':        { translation: 'hámster' },
  'parrot':         { translation: 'loro' },
  'horse':          { translation: 'caballo' },
  'snake':          { translation: 'serpiente' },
  'bird':          { translation: 'ave' },

  // ══════════════════════════════
  // UNIT 05-06 — Possessives
  // ══════════════════════════════
  'my':             { translation: 'mi / mis' },
  'your':           { translation: 'tu / tus' },
  'his':            { translation: 'su (de él)' },
  'her':            { translation: 'su (de ella)' },
  'our':            { translation: 'nuestro/a' },
  'their':          { translation: 'su (de ellos)' },
  'this':           { translation: 'este / esta' },
  'that':           { translation: 'ese / aquel' },
  'these':          { translation: 'estos / estas' },
  'those':          { translation: 'esos / aquellos' },

  // ══════════════════════════════
  // UNIT 07 — Everyday things
  // ══════════════════════════════
  'wallet':         { translation: 'billetera' },
  'keys':           { translation: 'llaves' },
  'phone':          { translation: 'teléfono' },
  'camera':         { translation: 'cámara' },
  'laptop':         { translation: 'computadora portátil' },
  'tablet':         { translation: 'tableta' },
  'book':           { translation: 'libro' },
  'notebook':       { translation: 'cuaderno' },
  'pencil':         { translation: 'lápiz' },
  'pen':            { translation: 'pluma / bolígrafo' },
  'dictionary':     { translation: 'diccionario' },
  'passport':       { translation: 'pasaporte' },
  'umbrella':       { translation: 'paraguas' },
  'glasses':        { translation: 'lentes / gafas' },
  'watch':          { translation: 'reloj (de pulsera)' },
  'magazine':       { translation: 'revista' },
  'newspaper':      { translation: 'periódico' },
  'map':            { translation: 'mapa' },
  'sandwich':       { translation: 'sándwich' },
  'apple':          { translation: 'manzana' },

  // ══════════════════════════════
  // UNIT 09-10 — Jobs
  // ══════════════════════════════
  'job':            { translation: 'trabajo / empleo' },
  'work':           { translation: 'trabajar / trabajo' },
  'doctor':         { translation: 'médico/a' },
  'nurse':          { translation: 'enfermero/a' },
  'teacher':        { translation: 'maestro/a' },
  'engineer':       { translation: 'ingeniero/a' },
  'chef':           { translation: 'chef / cocinero/a' },
  'farmer':         { translation: 'agricultor/a' },
  'actor':          { translation: 'actor / actriz' },
  'driver':         { translation: 'conductor/a' },
  'dentist':        { translation: 'dentista' },
  'scientist':      { translation: 'científico/a' },
  'pilot':          { translation: 'piloto' },
  'judge':          { translation: 'juez' },
  'mechanic':       { translation: 'mecánico/a' },
  'gardener':       { translation: 'jardinero/a' },
  'cleaner':        { translation: 'limpiador/a' },
  'waiter':         { translation: 'mesero/a' },
  'artist':         { translation: 'artista' },
  'vet':            { translation: 'veterinario/a' },
  'police officer': { translation: 'policía' },
  'hospital':       { translation: 'hospital' },
  'school':         { translation: 'escuela' },
  'office':         { translation: 'oficina' },
  'restaurant':     { translation: 'restaurante' },
  'farm':           { translation: 'granja' },
  'inside':         { translation: 'adentro / en interiores' },
  'outside':        { translation: 'afuera / en exteriores' },

  // ══════════════════════════════
  // UNIT 11 — Time
  // ══════════════════════════════
  'time':           { translation: 'hora / tiempo' },
  'morning':        { translation: 'mañana (tiempo del día)' },
  'afternoon':      { translation: 'tarde' },
  'evening':        { translation: 'noche (temprana)' },
  'night':          { translation: 'noche' },
  'midnight':       { translation: 'medianoche' },
  'noon':           { translation: 'mediodía' },
  "o'clock":        { translation: 'en punto' },
  'half past':      { translation: 'y media' },
  'quarter past':   { translation: 'y cuarto' },
  'quarter to':     { translation: 'menos cuarto' },

  // ══════════════════════════════
  // UNIT 12-13 — Daily Routines
  // ══════════════════════════════
  'wake up':        { translation: 'despertar(se)' },
  'get up':         { translation: 'levantarse' },
  'shower':         { translation: 'ducha / ducharse' },
  'breakfast':      { translation: 'desayuno' },
  'lunch':          { translation: 'almuerzo' },
  'dinner':         { translation: 'cena' },
  'go to work':     { translation: 'ir al trabajo' },
  'go home':        { translation: 'ir a casa' },
  'go to bed':      { translation: 'ir a dormir' },
  'start work':     { translation: 'comenzar a trabajar' },
  'finish work':    { translation: 'terminar de trabajar' },
  'leave work':     { translation: 'salir del trabajo' },
  'cook':           { translation: 'cocinar' },
  'eat':            { translation: 'comer' },
  'brush':          { translation: 'cepillar' },
  'walk the dog':   { translation: 'pasear al perro' },
  'every day':      { translation: 'todos los días' },

  // ══════════════════════════════
  // UNIT 14 — Days & Frequency
  // ══════════════════════════════
  'monday':         { translation: 'lunes' },
  'tuesday':        { translation: 'martes' },
  'wednesday':      { translation: 'miércoles' },
  'thursday':       { translation: 'jueves' },
  'friday':         { translation: 'viernes' },
  'saturday':       { translation: 'sábado' },
  'sunday':         { translation: 'domingo' },
  'weekend':        { translation: 'fin de semana' },
  'once a week':    { translation: 'una vez a la semana' },
  'twice a week':   { translation: 'dos veces a la semana' },

  // ══════════════════════════════
  // UNIT 15-16 — Negatives
  // ══════════════════════════════
  'not':            { translation: 'no (negación)' },
  'am not':         { translation: 'no soy / no estoy' },
  'is not':         { translation: 'no es / no está' },
  "isn't":          { translation: 'no es / no está' },
  'are not':        { translation: 'no son / no están' },
  "aren't":         { translation: 'no son / no están' },
  'do not':         { translation: 'no (presente simple)' },
  "don't":          { translation: 'no (yo/tú/nosotros)' },
  'does not':       { translation: 'no (él/ella)' },
  "doesn't":        { translation: 'no (él/ella)' },

  // ══════════════════════════════
  // VERBO TO BE — Core M1
  // ══════════════════════════════
  'am':             { translation: 'soy / estoy / tengo (yo)' },
  'is':             { translation: 'es / está / tiene (él/ella)' },
  'are':            { translation: 'eres / están / somos' },

};

export default M1_base;
